import type { Placement } from 'client-site-chrome-ui/types/locale';

export const setEventCategory = (placement: Placement) =>
  placement === 'footer' ? 'Footer' : 'Navigation - mobile menu';
